module.exports = __webpack_public_path__ + "img/table.cddf3bc8.png";